import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const {FiShield,FiDroplet,FiSun,FiArrowRight,FiPhone,FiStar}=FiIcons;

const benefits=[ 
  {icon: FiShield,label: "Long-Term Protection"},
  {icon: FiDroplet,label: "Hydrophobic Coating"},
  {icon: FiSun,label: "UV & Chemical Resistance"},
  {icon: FiStar,label: "Enhanced Gloss & Depth"},
];
const CERAMIC_IMG="https://images.unsplash.com/photo-1619551734325-81aaf323686c?auto=format&fit=crop&q=80";
const BOOKING_URL="https://app.urable.com/virtual-shop/cFNwotdAvEx76Evup5X1";

export default function CeramicHighlight() {
  return ( 
    <section className="py-24 bg-slate-950 relative overflow-hidden border-b border-slate-800"> 
      <div className="absolute inset-0 z-0"> 
        <img src={CERAMIC_IMG} alt="Ceramic coating Jacksonville FL" className="w-full h-full object-cover opacity-15" /> 
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/90 to-slate-950/60" /> 
      </div> 
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center"> 
          <motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} > 
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-600/20 border border-blue-500/30 rounded-sm text-blue-400 text-xs font-bold uppercase tracking-widest mb-6"> 
              <FiShield className="text-sm" /> Premium Upsell 
            </div> 
            <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-6"> 
              5-Year Ceramic<br /> 
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600"> Coating Service </span> 
            </h2> 
            <p className="text-slate-300 text-lg mb-8 leading-relaxed"> 
              Already included 1-year ceramic protection in our Elite Detail — but for ultimate,long-lasting defense,ask about our premium <strong className="text-white">5-Year Ceramic Coating</strong>. It chemically bonds to your paint for years of hydrophobic protection,UV resistance,and showroom gloss. 
            </p> 
            <div className="grid grid-cols-2 gap-4 mb-10"> 
              {benefits.map((b,i)=> ( 
                <div key={i} className="flex items-center gap-3"> 
                  <b.icon className="text-blue-500 text-lg flex-shrink-0" /> 
                  <span className="text-slate-300 text-sm font-semibold">{b.label}</span> 
                </div> 
              ))} 
            </div> 
            <div className="flex flex-col sm:flex-row gap-4"> 
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-blue-600 text-white font-bold rounded-sm hover:bg-blue-500 transition-all uppercase tracking-wide text-sm shadow-[0_0_24px_rgba(37,99,235,0.3)]" > 
                Book Your Ceramic <FiArrowRight /> 
              </a> 
              <a href="tel:9048312184" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border-2 border-slate-700 text-white font-bold hover:border-blue-500 hover:text-blue-400 transition-all rounded-sm uppercase tracking-wide text-sm" > 
                <FiPhone className="text-sm" /> Call (904) 831-2184 
              </a> 
            </div> 
          </motion.div> 
          <motion.div initial={{opacity: 0,scale: 0.95}} whileInView={{opacity: 1,scale: 1}} viewport={{once: true}} className="hidden lg:block" > 
            <div className="bg-gradient-to-br from-blue-600/20 to-blue-900/10 border border-blue-500/20 rounded-sm p-10 text-center"> 
              <FiShield className="text-blue-500 text-7xl mx-auto mb-6" /> 
              <div className="text-6xl font-black text-white mb-2">5</div> 
              <div className="text-blue-400 font-bold uppercase tracking-widest text-sm mb-4">Years of Protection</div> 
              <p className="text-slate-400 text-sm leading-relaxed max-w-xs mx-auto"> 
                One application. Half a decade of hydrophobic protection,UV defense,and gloss enhancement. 
              </p> 
              <div className="mt-8 pt-6 border-t border-blue-500/20"> 
                <p className="text-xs text-slate-500 uppercase tracking-widest font-bold">Ask About Our 5-Year Ceramic Coating Service</p> 
              </div> 
            </div> 
          </motion.div> 
        </div> 
      </div> 
    </section> 
  );
}